import React from 'react';
import PropTypes from 'prop-types';
import { SearchFilters } from './SearchFilters';

export const SearchRow = ({
    setState,
    state,
    tabDescription,
    tabTitle,
    tableSettings,
}) => {

    return (
        <div className='py-2 d-flex justify-content-between align-items-center'>
            <div className='d-flex flex-column search-row-header'>
                <h5 className='title-row text-truncate text-capitalize mb-0 font-gray-primary'>{ tabTitle }</h5>
                <p className='mr-1 font-gray-primary tab-description'>{ tabDescription }</p>
            </div>
            <SearchFilters
                setSuggestedAgentsState={setState}
                suggestedAgentsState={state}
                tableSettings={tableSettings}
            />
        </div>
    )
};

SearchRow.propTypes = {
    setState: PropTypes.func,
    state: PropTypes.object,
    tabTitle: PropTypes.string,
    tabDescription: PropTypes.string,
    tableSettings: PropTypes.object,
};
